import { Component, Input } from '@angular/core';
import {
  ProductLabels,
  ProductSummary,
} from '../../organisms/add-edit-product/add-edit-product.component';

@Component({
  selector: 'app-product-summary',
  templateUrl: './product-summary.component.html',
  styleUrls: ['./product-summary.component.scss'],
})
/**
 * Component to display a summary of a product.
 */
export class ProductSummaryComponent {
  @Input() product!: ProductSummary;
  @Input() labels!: ProductLabels;
  showDefaultImage? = false;

  /**
   * Returns the headers as a single string separated by semicolons.
   */
  get formattedHeaders(): string {
    if (this.product) {
      const headers = this.product.headers || [];
      const oldHeaders = this.product.oldHeaders || [];
      return [...oldHeaders, ...headers].join('; ');
    }
    return '';
  }
}
